module.exports = __webpack_public_path__ + "media/bootstrap-icons/graph-down-9988308a.svg";